import { JsonObject, JsonProperty } from 'json2typescript';
import { User } from '../users/user';


@JsonObject('Note')
export class Note {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('client_id', Number, true)
    clientId: number = undefined;

    @JsonProperty('note', String, true)
    note = '';

    @JsonProperty('added_by', User, true)
    addedBy = null;

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate = null;

    @JsonProperty('is_deleted', Boolean, true)
    isDeleted = false;
}

